<template>
  <div class="introduction">
    <h1 v-if="!smallScreen">{{ $t("title") }}</h1>
    <p v-if="!smallScreen" class="scroll-instruction">
      {{ $t("introduction.scrolldown") }}
    </p>

    <div class="flex-wrapper">
      <div v-if="!smallScreen" class="image-container" />

      <div class="content-container">
        <p>{{ $t("introduction.intro1") }}</p>

        <div :class="{ open: open }" class="more-about">
          <h2>{{ $t("introduction.intro2") }}</h2>

          <p class="light">{{ $t("introduction.intro3") }}</p>

          <p class="quote">{{ $t("introduction.intro4") }}</p>

          <p class="light">
            {{ $t("introduction.intro5") }}
            <router-link to="foundation">{{
              $t("introduction.intro6")
            }}</router-link
            >{{ $t("introduction.intro7") }}
          </p>
        </div>

        <f-button v-if="smallScreen" @click="toggleShowMore" :type="'outline'">
          <span v-if="!this.open">{{ $t("buttons.readMore") }}</span>
          <span v-else>{{ $t("buttons.readLess") }}</span>
        </f-button>
      </div>
    </div>
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  name: "introduction",
  components: {},
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggleShowMore: function () {
      this.open === true ? (this.open = false) : (this.open = true);
    },
  },
  // mounted() {
  // 	exampleFunction();
  // }
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
h2 {
  font-weight: 500;
}

p {
  margin-top: $p-padding;
  margin-bottom: $p-padding;
}

@include max-medium {
  .introduction {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 80px;

    .content-container > p {
      padding: 30px $padding-mobile 0;
    }

    .more-about {
      position: relative;
      height: 0;
      overflow: hidden;

      @include marion-background(0.6, 0.5);

      &.open {
        height: 100%;
        padding: 20px;
      }
    }

    button.outline {
      margin-top: 20px;
    }
  }
}

@include min-large {
  .introduction {
    padding-top: 20px;
    padding-bottom: 40px;
    @include maxWidthCenter;
  }

  .flex-wrapper {
    @include flex(center, stretch);
  }

  .image-container {
    position: relative;
    display: inline-block;
    width: 40%;
    padding: 40px;
    // background-color: white;
    @include image-background("photo_marion.jpg", center, center, cover);
    @include image-background("photo_marion_bw.png", center, center, cover);
    @include image-background(
      "photo_marion_bw_contrast.png",
      center,
      center,
      cover
    );
    // opacity: .6;

    // &:after {
    // 	content: "";
    // 	position: absolute;
    // 	top: 0;
    // 	left: 0;
    // 	right: 0;
    // 	bottom: 0;
    // 	background-color: $bright-green;
    // 	opacity: .4;
    // }
  }

  .content-container {
    display: inline-block;
    width: 60%;
    padding-left: 20px;
  }

  h1 {
    margin-bottom: 40px;
  }

  p.scroll-instruction {
    margin-bottom: 20px;
    font-size: 80%;
    color: grey;
    text-align: center;
  }

  h2 {
    margin-top: 30px;
    margin-bottom: 20px;
    text-align: left;
  }

  a {
    font-weight: bold;
    color: $dark-green;
  }
}
</style>
